export function getBackgroundImage(srcSet = '') {
	const imageSet = srcSet
		.split(', ')
		.map((str) => {
			const [url, dpi] = str.split(' ');
			return `url("${url}") ${dpi}`;
		})
		.join(', ');
	return `image-set(${imageSet})`;
}
